import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from './ui/button';
import { Languages } from 'lucide-react';

export default function LanguageSwitcher() {
    const { i18n } = useTranslation();

    const toggleLanguage = () => {
        const newLang = i18n.language === 'en' ? 'no' : 'en';
        i18n.changeLanguage(newLang);
    };

    return (
        <Button
            variant="ghost"
            size="icon"
            onClick={toggleLanguage}
            className="text-gray-500 hover:text-gray-900"
            title={`Switch to ${i18n.language === 'en' ? 'Norwegian' : 'English'}`}
        >
            <Languages className="h-5 w-5" />
            <span className="sr-only">Toggle language</span>
        </Button>
    );
}